import { FlatList } from 'react-native';
import { Surface as SurfaceBase } from 'react-native-paper';
import styled from 'styled-components/native';

import Button from '@src/components/Button';
import FontIcon from '@src/components/FontIcon';
import Image from '@src/components/Image';
import Separator from '@src/components/Separator';
import { maxWidth, padding, windowWidth } from '@src/configuration/constants';
import { ImmigrationMedia, Review } from '@src/types';

const MEDIA_PREVIEW_CARD_WIDTH = windowWidth * 0.6;
const MEDIA_PREVIEW_CARD_HEIGHT = MEDIA_PREVIEW_CARD_WIDTH / 2;

export const Cover = styled(Image)`
  width: 100px;
  height: 130px;
  resize-mode: contain;
`;

export const Row = styled.View`
  flex-direction: row;
`;

export const Column = styled.View`
  flex-direction: column;
`;

export const CenteredColumn = styled(Column)`
  align-items: center;
`;

export const CenteredRow = styled(Row)`
  justify-content: center;
`;

export const Content = styled.View`
  padding: ${padding}px;
`;

export const Star = styled(FontIcon).attrs({
  name: 'star-o',
  size: 14,
})``;

export const ReviewList = styled(FlatList as new () => FlatList<Review>).attrs(
  () => ({
    removeClippedSubviews: true,
    scrollEventThrottle: 8,
    initialNumToRender: 4,
    maxToRenderPerBatch: 4,
    keyExtractor: ({ user, date }) => user?.id + date,
    ItemSeparatorComponent: Separator,
    contentContainerStyle: {
      paddingBottom: padding,
      maxWidth: maxWidth,
      width: '100%',
      alignSelf: 'center',
      marginHorizontal: 'auto',
      paddingHorizontal: padding,
    },
  })
)``;

export const MediaPreviewList = styled(
  FlatList as new () => FlatList<ImmigrationMedia>
).attrs(() => ({
  horizontal: true,
  removeClippedSubviews: true,
  scrollEventThrottle: 8,
  keyExtractor: ({ id }) => id,
  ItemSeparatorComponent: Separator,
  showsHorizontalScrollIndicator: false,
  contentContainerStyle: {
    paddingHorizontal: padding,
    paddingBottom: 5,
  },
}))``;

export const Surface = styled(SurfaceBase)`
  elevation: 4;
  border-radius: ${({ theme }) => theme.roundness}px;
  background-color: ${({ theme }) => theme.colors.placeholder};
  margin-bottom: ${padding / 2}px;
  overflow: hidden;
`;

export const MediaPreview = styled(Image)`
  width: ${MEDIA_PREVIEW_CARD_WIDTH}px;
  height: ${MEDIA_PREVIEW_CARD_HEIGHT}px;
`;

export const ReviewButton = styled(Button).attrs(({ theme }) => ({
  mode: 'outlined',
  color: theme.colors.text,
  compact: true,
  uppercase: false,
}))``;

export const ModalContainer = styled(SurfaceBase)`
  elevation: 4;
  border-radius: ${({ theme }) => theme.roundness}px;
  background-color: ${({ theme }) => theme.colors.background};
  padding: ${padding * 2}px ${padding}px;
  overflow: hidden;
  width: 80%;
  min-height: 50%;
  align-self: center;
  justify-content: space-around;
  align-items: stretch;
`;
